import { Token } from '@cigna/resource-content/contracts';
import { InjectionToken, TemplateRef } from '@angular/core';

export interface Renderer {
  token: Token;
}

export const RENDER_CONFIG = new InjectionToken('RENDER_CONFIG');
export type RenderConfig = () => {
  params: {};
  templates: { [key: string]: Array<TemplateRef<any>> };
};
